/**
 * Search Toggle functionality
 *
 * @description This file includes the required functionality for the blog menu search toggle
 *
 * @return void
 * @access public
 *
 */

import {addEventListenerIfElExists} from './helpers';

export const searchToggle = () => {
	const openSearchFormBtn  = document.querySelector( '.js-open-search-form' );
	const closeSearchFormBtn = document.querySelector( '.js-close-search-form' );
	const blogMenuSearchForm = document.querySelector( '.c-blog-menu__form' );
	const activeClass        = 'is-active';


	/*
	 * Open Search Form functionality
	 */
	function openSearchForm( el ) {
		el.preventDefault();

		blogMenuSearchForm.classList.add( activeClass );
	}

	/*
	 * Close Search Form functionality
	 */
	function closeSearchForm( el ) {
		el.preventDefault();

		blogMenuSearchForm.classList.remove( activeClass );
	}

	addEventListenerIfElExists( openSearchFormBtn, openSearchForm )
	addEventListenerIfElExists( closeSearchFormBtn, closeSearchForm )

}
